import {match} from 'ts-pattern';

import {useLocation} from 'react-router-dom';

import {sourcingRoutes} from '@dms/routes';

import {SourcingPage} from '../types/SourcingPage';

export function useSourcingPage(): SourcingPage {
  const location = useLocation();

  return match(location.pathname)
    .with(sourcingRoutes.classifieds_userFavourite, () => SourcingPage.FAVORITES_PAGE)
    .with(sourcingRoutes.auctions_userFavourite, () => SourcingPage.FAVORITES_PAGE)
    .with(sourcingRoutes.classifieds_userToBuy, () => SourcingPage.CART_PAGE)
    .with(sourcingRoutes.auctions_userToBuy, () => SourcingPage.CART_PAGE)
    .with(sourcingRoutes.classifieds_comparison, () => SourcingPage.COMPARISON_PAGE)
    .with(sourcingRoutes.auctions_comparison, () => SourcingPage.COMPARISON_PAGE)
    .with(sourcingRoutes.classifieds_userHidden, () => SourcingPage.HIDDEN_PAGE)
    .with(sourcingRoutes.auctions_userHidden, () => SourcingPage.HIDDEN_PAGE)
    .with(sourcingRoutes.classifieds_userCarvagoBuy, () => SourcingPage.CARVAGO_BUY_PAGE)
    .otherwise(() => SourcingPage.DEFAULT);
}
